import { render, staticRenderFns } from "./BannerDialog.vue?vue&type=template&id=7d23a078"
import script from "./BannerDialog.vue?vue&type=script&lang=js"
export * from "./BannerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d23a078')) {
      api.createRecord('7d23a078', component.options)
    } else {
      api.reload('7d23a078', component.options)
    }
    module.hot.accept("./BannerDialog.vue?vue&type=template&id=7d23a078", function () {
      api.rerender('7d23a078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/banner/components/BannerDialog.vue"
export default component.exports